/**
 * Параметры шага
 */
export type PlayControlOptions = {
  stroke?: string
}

export class PlayControl {
  private readonly animation: Animation
  private readonly scale: SVGCircleElement
  private readonly controlButton: SVGSVGElement
  private readonly next: () => PlayControlOptions

  /**
   * Кнопка управления переключением элементов списков
   * @param element SVG кнопка
   * @param duration длительность шага
   * @param next действие после завершения шага
   */
  constructor(controlButton: SVGSVGElement, duration: number, next: () => PlayControlOptions) {
    this.controlButton = controlButton
    this.next = next
    this.scale = controlButton.querySelector<SVGCircleElement>('#scale')!
    const effect = new KeyframeEffect(
      this.scale,
      [{ strokeDashoffset: 302 }, { strokeDashoffset: 0 }],
      {
        duration,
        easing: 'linear',
        fill: 'forwards'
      }
    )
    this.animation = new Animation(effect)

    this.animation.addEventListener('finish', () => {
      const options = this.next()
      this.update(options)
      this.reset()
      this.play()
    })

    this.controlButton.addEventListener('click', () => {
      switch (this.animation.playState) {
        case 'idle':
        case 'paused':
          this.play()
          break
        case 'running':
          this.pause()
          break
      }
    })
  }

  update(options: PlayControlOptions) {
    if (options.stroke) {
      this.controlButton.attributeStyleMap.set('color', options.stroke)
    }
  }

  play() {
    this.controlButton.classList.add('playing')
    this.animation.play()
  }

  pause() {
    this.controlButton.classList.remove('playing')
    this.animation.pause()
  }

  reset() {
    this.animation.currentTime = 0
  }
}
